// US-dollar wording shared by the Health and Checkout pages (OMG-2793).

/** Dollars with cents only under $10, where a tenth of a plan's price is the
 *  thing to notice: "$52", "$3.10". */
export const formatUsd = (value: number): string =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: value < 10 ? 2 : 0,
  }).format(value);

/** The one-line verdict on a currency's USD average against the US list
 *  price of the same plans, in the words the ticket asked for:
 *  "ARS: $3.10 avg, expect about $49". */
export const mispricingText = (
  currency: string,
  usd: { averageOrder: number; expectedAverageOrder: number | null },
): string => {
  const avg = `${currency}: ${formatUsd(usd.averageOrder)} avg`;
  return usd.expectedAverageOrder === null
    ? avg
    : `${avg}, expect about ${formatUsd(usd.expectedAverageOrder)}`;
};

/** Mirrors MISPRICING_FACTOR in omg-api's usdPricingService: a currency is
 *  flagged beyond this many times the US list price either way. */
export const MISPRICING_FACTOR = 4;

/** "under a quarter of list" / "over 4x list", for a flag; "" for none. */
export const flagWording = (flag: "low" | "high" | null): string =>
  flag === null
    ? ""
    : flag === "low"
      ? `under ${MISPRICING_FACTOR === 4 ? "a quarter" : `1/${MISPRICING_FACTOR}`} of list`
      : `over ${MISPRICING_FACTOR}x list`;
